//import { Fancybox, Carousel, Panzoom } from "@fancyapps/ui";
import { Fancybox } from '@fancyapps/ui';

const fancyInit = () => {

  Fancybox.bind('[data-fancybox]', {
    Image: {
      zoom: false,
    },
    type: "inline",
    hideOnOverlayClick: false,
    // Set `touch: false` to disable panning/swiping
    touch: false,
    panOnlyZoomed: false,
    friction: 0,
      draggableClass: 'hello',
  });

  Fancybox.bind('[data-fancybox="gallery"]', {
    //dragToClose: false,
    Thumbs: false,

    Image: {
      zoom: false,
      click: false,
      wheel: 'slide',
    },

    on: {
      // Move caption inside the slide
      reveal: (f, slide) => {
        slide.$caption && slide.$content.appendChild(slide.$caption);
      },
    },
  });

};

export { fancyInit };
